/**
 * AdminLayout — wrapper des pages /admin/*
 *
 * Particularité : le badge rôle est "Super-admin" en bordeaux (ton sombre,
 * autorité), pas tomate (la tomate reste réservée aux espaces non-admin et
 * aux CTAs principaux).
 */
import { AuthLayoutShell } from './AuthLayoutShell';
import { SidebarLink } from '@/components/passage/SidebarLink';

export function AdminLayout() {
  return (
    <AuthLayoutShell
      homePath="/admin"
      roleLabel="Super-admin"
      roleColor="bordeaux"
      navAriaLabel="Navigation administration"
      footerText={`© ${new Date().getFullYear()} Stelvyo — espace super-administrateur`}
      sidebar={
        <>
          <SidebarLink to="/admin" end>Tableau de bord</SidebarLink>
          <SidebarLink to="/admin/utilisateurs">Utilisateurs</SidebarLink>
          <SidebarLink to="/admin/etablissements">Établissements</SidebarLink>
          <SidebarLink to="/admin/annonces">Annonces</SidebarLink>
          <SidebarLink to="/admin/annonces-externes">Annonces externes</SidebarLink>
          <SidebarLink to="/admin/annonces-rejetees">Annonces rejetées</SidebarLink>
          <SidebarLink to="/admin/candidatures">Candidatures</SidebarLink>
          {/* V13 — CRM recrutement */}
          <SidebarLink to="/admin/suivi-recrutements">Suivi recrutements</SidebarLink>
          <SidebarLink to="/admin/reseau">Réseau cross-formation</SidebarLink>
          <SidebarLink to="/admin/ia">Paramètres IA</SidebarLink>
          <SidebarLink to="/admin/journal">Journal d'audit</SidebarLink>
          <SidebarLink to="/admin/retention-donnees">Rétention RGPD</SidebarLink>
          <SidebarLink to="/admin/configuration">Configuration</SidebarLink>
          <SidebarLink to="/admin/guide-alternance">Guide alternance</SidebarLink>
          <hr className="border-dashed border-passage-hairline" />
          <SidebarLink to="/admin/navigation-cachee">Navigation cachée</SidebarLink>
        </>
      }
    />
  );
}
